var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Layout',[_c('imageList',{attrs:{"imageList":_vm.imageList,"isDouble":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }